import {
  getProductListElementName,
  getProductListEPDNames,
  getProductListGroupDisplayName,
  PRODUCT_LIST_EPD_NAME_SEPARATOR,
} from '../../product-list.helpers';
import { NodonTheme } from '@client/style';
import { Typography } from '@mui/material';
import {
  isProductListCategoryGroup,
  isProductListItem,
} from '@shared/helpers/recursive-element.helpers';
import { OneOfProductListChildren } from '@shared/models/project.model';
import { EllipsisText } from '@ui/EllipsisText/EllipsisText';
import React from 'react';
import { useSelectedVersionProductsAndStoreProducts } from '@client/store/ui';

type ProductListItemNameProps = {
  element: OneOfProductListChildren;
};

export const ProductListItemName: React.FC<ProductListItemNameProps> = ({
  element,
}) => {
  const productLookup = useSelectedVersionProductsAndStoreProducts();

  if (isProductListCategoryGroup(element) || isProductListItem(element)) {
    const name = getProductListElementName(element, { productLookup });

    if (isProductListCategoryGroup(element)) {
      return (
        <EllipsisText tooltipTitle={name}>
          <Typography
            component="span"
            variant="h6"
            sx={{
              textTransform: 'uppercase',
            }}
          >
            {name}
          </Typography>
        </EllipsisText>
      );
    }

    const tooltipTitle = getProductListElementName(element, {
      disableTruncation: true,
    });

    return (
      <EllipsisText tooltipTitle={tooltipTitle}>
        <Typography component="span" variant="body2">
          {name}
        </Typography>
      </EllipsisText>
    );
  }

  const [epdName, genericName] = getProductListEPDNames(element, productLookup);
  const tooltipTitle = getProductListGroupDisplayName(element, productLookup);

  return (
    <EllipsisText tooltipTitle={tooltipTitle}>
      {genericName && (
        <Typography
          component="span"
          variant="body2"
          color={NodonTheme.palette.neutral.light}
        >
          {`${genericName}${PRODUCT_LIST_EPD_NAME_SEPARATOR}`}
        </Typography>
      )}
      <Typography component="span" variant="body2">
        {epdName}
      </Typography>
    </EllipsisText>
  );
};
